<template>
	<div>

		<v-subheader>Your Team</v-subheader>

		<v-list subheader>
			<v-list-tile v-for="dailyScrum in dailyScrums" :key="dailyScrum.id" class="mb-1" avatar @click="selectDailyScrum(dailyScrum)">
				<v-list-tile-avatar>
					<img :src="getAvatar(dailyScrum.employee.id)" alt="avatar" class="avatar-img" />
				</v-list-tile-avatar>

				<v-list-tile-content>
					<v-list-tile-title v-html="dailyScrum.employee.fullName"></v-list-tile-title>
					<v-list-tile-sub-title>
						<!-- <v-icon small color="green" class="mr-1">check_circle</v-icon> -->
							<!-- <span v-if="!dailyScrum.updatedDateUtc"><span>Completed </span><AppDate :date="dailyScrum.createdDateUtc" /></span>
						<span v-else><span>Updated </span><AppDate :date="dailyScrum.updatedDateUtc" /></span> -->

						<span>{{dailyScrum.items[1].answer}}</span>
					
					</v-list-tile-sub-title>
				</v-list-tile-content>
			</v-list-tile>
		</v-list>

		<v-dialog v-if="selectedDailyScrum != null" v-model="dialog" persistent max-width="600px">
			<v-card>
				<v-toolbar flat dense cad class="info" dark>
					<v-toolbar-title class="subheading">
						{{ selectedDailyScrum.employee.fullName }}
						<span class="info-text"> - {{ selectedDailyScrum.scrumDateUtc | formatDate('dddd, DD MMM YYYY') }}</span>
					</v-toolbar-title>
				</v-toolbar>

				<v-card-text class="text-xs-left">
					<daily-scrum :dailyScrum="selectedDailyScrum" />
				</v-card-text>

				<v-card-actions>
					<div class="created-updated ml-3">
						<div v-if="!selectedDailyScrum.updatedDateUtc">
							<span>Completed </span>
							<AppDate :date="selectedDailyScrum.createdDateUtc" />
						</div>
						<div v-else>
							<span>Updated </span>
							<AppDate :date="selectedDailyScrum.updatedDateUtc" />
						</div>
					</div>
					<v-spacer></v-spacer>
					<v-btn flat @click="closeDialog">Close</v-btn>
				</v-card-actions>

			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import avatarMixin from '@/mixins/avatarMixin';
	import DailyScrum from '@/components/dailyScrum/DailyScrum';

	export default {
		props: {
			dailyScrums: {
				type: Array,
				required: true
			}
		},
		data() {
			return {
				selectedDailyScrum: null,
				dialog: false
			};
		},
		components: {
			DailyScrum
		},
		mixins: [avatarMixin],
		methods: {
			selectDailyScrum(dailyScrum) {
				this.selectedDailyScrum = dailyScrum;
				this.dialog = true;
			},
			closeDialog() {
				this.selectedDailyScrum = null;
				this.dialog = false;
			}
		}
	};
</script>

<style scoped>
	.created-updated {	
		font-style: italic;
    	font-size: 12px;
	}
	.info-text {
		font-size: 12px !important;
	}
</style>
